import { OrganizationCompetencyFragment } from "types/graphql-schema";

import { getCompetencyAppliesToTag } from "./competency-sharing";

// Under a competency's name in the tables: who it applies to, in the grey of
// the "Editing here only affects…" note.
const AppliesToTag = ({
  competency,
  careerTrackId,
}: {
  competency: Pick<
    OrganizationCompetencyFragment,
    | "appliesTo"
    | "appliesToIcRoles"
    | "appliesToManagementRoles"
    | "appliesToTeams"
    | "appliesToCareerTracks"
  >;
  // The track being viewed, which the tag calls "this career track".
  careerTrackId?: number | null;
}) => (
  <div
    className="mt-1 inline-block rounded-sm bg-gray-100 px-1.5 py-0.5 text-xs font-normal text-gray-600"
    aria-label="Competency applies to"
  >
    {getCompetencyAppliesToTag(competency, careerTrackId)}
  </div>
);

export default AppliesToTag;
